import type { UploadFile } from 'antd/es/upload/interface';
import type { RcFile } from 'antd/es/upload';

const getExtFromMime = (mime: string): string => {
  if (mime === 'image/jpeg') return 'jpg';
  if (mime === 'image/png') return 'png';
  if (mime === 'image/webp') return 'webp';
  if (mime === 'image/gif') return 'gif';
  const slashIndex = mime.indexOf('/');
  return slashIndex >= 0 ? mime.slice(slashIndex + 1) : 'png';
};

const makeUid = (): string => {
  return `uid-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const extractClipboardImageFiles = (e: ClipboardEvent): File[] => {
  const items = e.clipboardData?.items;
  if (!items || items.length === 0) return [];

  const images: File[] = [];
  for (const item of Array.from(items)) {
    if (!item.type || !item.type.startsWith('image/')) continue;
    const file = item.getAsFile();
    if (file) images.push(file);
  }
  return images;
};

export const fileToUploadFile = (file: File): UploadFile => {
  const ext = getExtFromMime(file.type || 'image/png');
  const name =
    file.name && file.name.trim().length > 0
      ? file.name
      : `pasted-${Date.now()}.${ext}`;

  // antd Upload 的类型里 originFileObj 通常是 RcFile(File + uid)
  // 这里保持为真正的 File 对象，避免把二进制内容“展开”成普通对象丢失。
  const rcFile = Object.assign(file, { uid: makeUid() }) as unknown as RcFile;
  return {
    uid: makeUid(),
    name,
    status: 'done',
    originFileObj: rcFile,
    type: file.type,
  };
};
